import React, { useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import SocialOption from "./Options/SocialOption.js";
import DesignOption from "./Options/DesignOption.js";
import SeoOption from "./Options/SeoOption.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import FormsOption from "./Options/FormsOption.js";
import Image from "components/Elements/Image/Image.tsx";
import config from "config";
import Button from "components/Elements/Button/Button.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import { EMAIL_VALIDATOR, urlRegex } from "helpers/validators.js";

const Settings = ({
  FullDetailsEmbedPage,
  setTypeOfSettings,
  type,
  setIsOpen,
  isDefaultBackgrounds, //DESIGN
  setBackgroundImagesList,
  backgroundImagesList,
  setSingleOrRotate,
  singleOrRotate,
  setBrandingColor,
  brandingColor,
  pageLanguage,
  setPageLanguage,
  EmbedPageFormList, //FORMS
  setEmbedPageFormList,
  selectedForms,
  setSelectedForms,
  showOrderTracker,
  setShowOrderTracker,
  userFormsList,
  socialLinks, //SOCIAL
  diractionPage,
  setDiractionPage,
  personalPageUrl,
  browserTitle, //SEO
  setBrowserTitle,
  headScripts,
  setHeadScripts,
  metaDescription,
  setMetaDescription,
  searchEngines,
  setSearchEngines,
  bodyScripts,
  setBodyScripts,
  displayFormDetialsDB,
  setDisplayFormDetialsDB,
  displaySidePanel,
  setDisplaySidePanel,
}) => {
  const { getTextByKey, getPath } = useContent();
  const { addToast } = useToasts();
  const [loading2, setLoading2] = useState(false);
  //Social
  const [invalidURL, setInvalidURL] = useState([]);
  //Settings
  const [invalidUserName, setInvalidUserName] = useState(false);
  const [tempBrandingColor, setTempBrandingColor] = useState(brandingColor);
  const [tempUserName, setTempUserName] = useState(personalPageUrl);
  const [existUserName, setExistUserName] = useState(false);
  const [hideSidePanel, setHideSidePanel] = useState(false);
  const updateDesign = (type, value) => {
    updateDesignSettings(type, value);
  };

  const validateUrl = (url, type) => {
    const validURL = new RegExp(urlRegex);
    if (url) {
      if (validURL.test(url)) {
        return null;
      } else {
        setInvalidURL((prev) => [...prev, type]);
        return type;
      }
    }
    return null;
  };

  const validateEmail = (email, type) => {
    const validURL = new RegExp(EMAIL_VALIDATOR);
    if (email) {
      if (validURL.test(email)) {
        return null;
      } else {
        setInvalidURL((prev) => [...prev, type]);
        return type;
      }
    }
    return null;
  };

  const validateWhatsapp = (url, type) => {
    const validURL = new RegExp(urlRegex);
    if (url) {
      if (validURL.test(url)) {
        return null;
      } else {
        setInvalidURL((prev) => [...prev, type]);
        return type;
      }
    }
    return null;
  };

  const validatePhone = (url, type) => {
    const validURL = new RegExp(urlRegex);
    if (url) {
      if (validURL.test(url)) {
        return null;
      } else {
        setInvalidURL((prev) => [...prev, type]);
        return type;
      }
    }
    return null;
  };

  //Update social links
  const updateSocialLinks = () => {
    let invalidSocial = [];

    socialLinks.forEach((element) => {
      if (
        element.name.toLowerCase() !== "email" &&
        element.name.toLowerCase() !== "phone" &&
        element.name.toLowerCase() !== "whatsapp"
      ) {
        const socialInvalid = validateUrl(
          element.state,
          element.name.toLowerCase()
        );
        socialInvalid !== null && invalidSocial.push(socialInvalid);
      } else if (element.name.toLowerCase() === "email") {
        const socialInvalidEmail = validateEmail(
          element.state,
          element.name.toLowerCase()
        );
        socialInvalidEmail !== null && invalidSocial.push(socialInvalidEmail);
      } else {
        //here need to validate email, phone and whatsapp
      }
    });

    if (!invalidSocial.length > 0) {
      let tempSocialLinks = {
        Website: "",
        YouTube: "",
        Twitter: "",
        Facebook: "",
        Instagram: "",
        Vimeo: "",
        Linkedin: "",
        Whatsapp: "",
        Phone: "",
        Email: "",
      };
      socialLinks.forEach((element) => {
        tempSocialLinks[element.title] = element.state;
      });
      tempSocialLinks["EmbedDynamicPageId"] =
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageId;
      tempSocialLinks["EmbedDynamicPageActive"] =
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageActive;

      updateEmbedDynamicSocialLinks(tempSocialLinks);
    }
  };

  const updateFormsList = () => {
    let updateForms = {
      EmbedDynamicPageId: FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageId,
      EmbedDynamicPageUsername:
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageUserName,
      EmbedDynamicPageActive:
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageActive,
      EmbedDynamicPageFormIdsList: selectedForms,
    };
    updateEmbedDynamicPageFormList(updateForms, false);
  };

  const updateSeoScripts = () => {
    let embedScripts = {
      EmbedDynamicPageUsername: tempUserName,
      EmbedDynamicPageScriptHead: headScripts,
      EmbedDynamicPageScriptBody: bodyScripts,
      EmbedDynamicPageScriptMetaDescription: metaDescription,
      EmbedDynamicPageScriptBrowserTitle: browserTitle,
      EmbedDynamicPageId: FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageId,
      EmbedDynamicPageActive:
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageActive,
    };
    let displayStatus = false;
    if (
      (FullDetailsEmbedPage.EmbedDynamicPageScripts &&
        FullDetailsEmbedPage.EmbedDynamicPageScripts.EmbedPageScriptHead !==
          headScripts) ||
      (FullDetailsEmbedPage.EmbedDynamicPageScripts &&
        FullDetailsEmbedPage.EmbedDynamicPageScripts.EmbedPageScriptBody !==
          bodyScripts)
    ) {
      displayStatus = true;
    }
    if (!invalidUserName) {
      updateEmbedPageScripts(embedScripts, displayStatus);
    }
  };

  const updateEmbedDynamicPageFormList = async (body, isLoading) => {
    setLoading2(true);

    const response = await apiRequest(
      "EmbedDynamics",
      "UpdateEmbedPageFormListReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        if (response.data.EmbedDybamicPageResponseCode === 0) {
          if (isLoading) {
            closeSidePanel();
          }
        }
      }
    }

    setLoading2(false);
  };

  const updateEmbedDynamicSocialLinks = async (body) => {
    setLoading2(true);
    const response = await apiRequest(
      "EmbedDynamics",
      "ReactUpdateEmbedDynamicSocialLinks",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        if (response.data.ReturnCode === 0) {
        }
      }
    }
    closeSidePanel();
    setLoading2(false);
  };

  const updateEmbedPageScripts = async (body, displayStatus) => {
    setLoading2(true);
    let ifChangeUserName = false;
    if (
      body.EmbedDynamicPageUsername !==
      FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageUserName
    ) {
      ifChangeUserName = true;
    }
    const response = await apiRequest(
      "EmbedDynamics",
      "UpdateEmbedPageScriptsReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        if (response.data.ReturnCode === 0) {
          if (displayStatus) {
            addToast(getTextByKey("new-script-request-message"), {
              appearance: "success",
            });
          }
          if (ifChangeUserName) {
            window.location.href =
              config.baseurl +
              getPath() +
              "page-edit/" +
              body.EmbedDynamicPageUsername;
          }
          closeSidePanel();
        } else if (response.data.ReturnCode === 450071) {
          setExistUserName(true);
        }
      }
    }
    setLoading2(false);
  };

  const updateDesignSettings = async (type, value) => {
    setLoading2(true);
    const body = {
      EmbedDynamicPageId: FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageId,
      EmbedDynamicPageUsername:
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageUserName,
      EmbedDynamicPageActive:
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageActive,
      EmbedDynamicPageBackgroundDisplay:
        type === "singleOrRotate" ? value : singleOrRotate,
      EmbedDynamicPageDirection: type === "direction" ? value : diractionPage,
      EmbedDynamicPageBrandingColor:
        type === "brandingColor" ? value : tempBrandingColor,
      EmbedDynamicPageLanguage: type === "language" ? value : pageLanguage,
      EmbedDynamicPageDisplayFormDetails:
        type === "displayFormDetails" ? value : displayFormDetialsDB,
      EmbedDynamicPageDisplaySidePanel:
        type === "displaySidePanel" ? value : displaySidePanel,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "ReactUpdateEmbedPageDesign",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        if (response.data.EmbedDybamicPageResponseCode === 0) {
          setBrandingColor(tempBrandingColor);
        }
      }
    }
    setLoading2(false);
  };

  const panelList = {
    design: {
      component: (
        <DesignOption
          singleOrRotate={singleOrRotate}
          setSingleOrRotate={setSingleOrRotate}
          backgroundImagesList={backgroundImagesList}
          setBackgroundImagesList={setBackgroundImagesList}
          FullDetailsEmbedPage={FullDetailsEmbedPage}
          diractionPage={diractionPage}
          setDiractionPage={setDiractionPage}
          setBrandingColor={setBrandingColor}
          brandingColor={brandingColor}
          setTempBrandingColor={setTempBrandingColor}
          isDefaultBackgrounds={isDefaultBackgrounds}
          updateDesign={updateDesign}
          setIsOpen={setIsOpen}
          setTypeOfSettings={setTypeOfSettings}
          setHideSidePanel={setHideSidePanel}
          pageLanguage={pageLanguage}
          setPageLanguage={setPageLanguage}
          displayFormDetialsDB={displayFormDetialsDB}
          setDisplayFormDetialsDB={setDisplayFormDetialsDB}
          displaySidePanel={displaySidePanel}
          setDisplaySidePanel={setDisplaySidePanel}
        />
      ),
      updateFunction: () => updateDesign(),
    },
    seo: {
      component: (
        <SeoOption
          headScripts={headScripts}
          setHeadScripts={setHeadScripts}
          bodyScripts={bodyScripts}
          setBodyScripts={setBodyScripts}
          setMetaDescription={setMetaDescription}
          metaDescription={metaDescription}
          setBrowserTitle={setBrowserTitle}
          browserTitle={browserTitle}
          scriptsDetails={
            FullDetailsEmbedPage &&
            FullDetailsEmbedPage.EmbedDynamicPageScripts &&
            FullDetailsEmbedPage.EmbedDynamicPageScripts
          }
          setInvalidUserName={setInvalidUserName}
          invalidUserName={invalidUserName}
          setTempUserName={setTempUserName}
          tempUserName={tempUserName}
          setExistUserName={setExistUserName}
          existUserName={existUserName}
          searchEngines={searchEngines}
          setSearchEngines={setSearchEngines}
          FullDetailsEmbedPage={FullDetailsEmbedPage}
        />
      ),
      updateFunction: () => updateSeoScripts(),
    },
    forms: {
      component: (
        <FormsOption
          setSelectedForms={setSelectedForms}
          selectedForms={selectedForms}
          updateFormsList={updateFormsList}
          FullDetailsEmbedPage={FullDetailsEmbedPage}
          EmbedPageFormList={EmbedPageFormList}
          setEmbedPageFormList={setEmbedPageFormList}
          showOrderTracker={showOrderTracker}
          setShowOrderTracker={setShowOrderTracker}
          userFormsList={userFormsList}
        />
      ),
      updateFunction: () => updateFormsList(),
    },
    social: {
      component: (
        <SocialOption
          invalidURL={invalidURL}
          socialLinks={socialLinks}
          setInvalidURL={setInvalidURL}
        />
      ),
      updateFunction: () => updateSocialLinks(),
    },
  };

  const closeSidePanel = () => {
    setIsOpen(false);
    setTimeout(() => {
      setTypeOfSettings(null);
    }, 500);
  };

  return (
    <div className={`settings-body ${hideSidePanel ? "hide" : "show"}`}>
      <div
        className="exit-div exit-panel"
        onClick={() => {
          closeSidePanel();
        }}
      >
        <Icon name="x" />
      </div>
      {panelList[type].component}
      {type !== "forms" && type !== "design" && (
        <>
          <div className="save-button">
            <Button onClick={() => panelList[type].updateFunction()}>
              {loading2 ? (
                <Image
                  className="loader-animation-gif"
                  name="preloader"
                  ext="gif"
                />
              ) : (
                getTextByKey("save")
              )}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default Settings;
